module.exports = __webpack_public_path__ + "img/camera-rotate.023c4214.svg";